/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { NAVIGATION_ITEMS_PAGE_SIZE } from '@atlassian/jira-navigation-kit-common/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from './src/ui/__generated__/HorizontalNavPlansQuery$parameters';

function toPlanScenarioAri({
	siteId,
	activationId,
	planId,
	scenarioId,
}: {
	siteId: string;
	activationId: string;
	planId: string;
	scenarioId: string;
}) {
	return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}

export const plansHorizontalNavigationEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-plans-horizontal-nav-entrypoint" */ './src/ui/HorizontalNavPlans'
			),
		{ includeInShellOnlySsrBundle: true },
	),
	getPreloadProps: ({
		context: { match },
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		const planId = match.params.planId;
		const scenarioId = match.params.scenarioId;

		if (!planId) {
			throw new Error('Plan Id is missing');
		}
		if (!scenarioId) {
			throw new Error('Scenario Id is missing');
		}

		const planScenarioAri = toPlanScenarioAri({
			siteId: cloudId,
			activationId,
			planId,
			scenarioId,
		});
		return {
			queries: {
				horizontalNavPlansQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						first: NAVIGATION_ITEMS_PAGE_SIZE,
						cloudId,
						containerNavigationInput: {
							scopeId: planScenarioAri,
						},
						isPlanRovoListenerEnabled: fg('jira_plan_rovo_listener'),
					},
				},
			},
		};
	},
});
